import { render } from "./ModelPage.vue?vue&type=template&id=c5505166"
import script from "./ModelPage.vue?vue&type=script&lang=js"
export * from "./ModelPage.vue?vue&type=script&lang=js"

import "./ModelPage.vue?vue&type=style&index=0&id=c5505166&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__